import { IFloorPayload } from "../../../components/FacilityManager/Domain/Types/FloorPlan/FloorPayload.type";
import { isValidPlanDateRangeStrings } from "../../../features/Booking-Form/functions/floor.functions";
import { useMutation } from "react-query";
import axios from "axios";

interface RequestBody {
  floorInventoryId: number;
  dto: {
    start: string;
    end: string | null;
  };
}

export function useRemoteMutateFetchFloorPlanService() {
  return useMutation<IFloorPayload | undefined, Error, RequestBody>({
    mutationFn: async (params: RequestBody) => {
      if (!isValidPlanDateRangeStrings(params.dto.start, params.dto.end)) {
        return undefined;
      }
      const response = await axios.get<IFloorPayload>(`/plan/${params.floorInventoryId}/services`, {
        params: {
          end: params.dto.end as string,
          start: params.dto.start
        }
      });
      return response.data;
    }
  });
}
